/*jslint node: true*/
"use strict";

var ko = require("pli/knockout");
var pli = require("pli/forms");
var pliObservable = require("pli/forms-knockoutcontrols");

var dataCache = require("../datacache");
var entityRegistry = require("../entity-registry");
var picklistItemExtensions = require("../picklist-common/picklistItemViewModelExtensions");


//-------------------------------------------
var defaultConversionFactor = 2.47105381,
    provinceStateForm = pli.forms.registry.provinceStateForm;

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// ProvinceStateViewModel
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
function ProvinceStateViewModel(form) {
    this.initPicklistItem("Geo-ProvinceState-", form);

    this.code = this.id = pliObservable(null, null, "required");
    this.description = pliObservable();
    this.crownConversion = pliObservable(null, null, "required", "numeric");
    this.freeholdConversion = pliObservable(null, null, "required", "numeric");

    this.extras.isFixed = ko.observable(false);
    this.extras.displayName = ko.computed(ProvinceStateViewModel.prototype._computeDisplayName, this);
}


//-------------------------------------------
ProvinceStateViewModel.prototype.fromCacheItem = function provinceStateFromCacheItem(item) {
    var record;
    if (item && item.length) {
        record = {
            guid: item[item.length - 1],
            code: item[0],
            description: item[1],
            crownConversion: (item[2] ? parseFloat(item[2]) : null),
            freeholdConversion: (item[3] ? parseFloat(item[3]) : null),
            isFixed: item[4] || false
        };
    } else {
        record = item;
    }
    return record;
};


//-------------------------------------------
ProvinceStateViewModel.prototype.load = function loadProvinceState(record) {
    record = record || {};

    this.code.reset();
    this.description.reset();
    this.crownConversion.reset();
    this.freeholdConversion.reset();

    this.guid(record.guid || null);
    this.code.load(record.code);
    this.description.load(record.description);
    this.crownConversion.load(record.crownConversion || defaultConversionFactor);
    this.freeholdConversion.load(record.freeholdConversion || defaultConversionFactor);

    this.extras.isFixed(record.isFixed);
};


//-------------------------------------------
ProvinceStateViewModel.prototype._computeDisplayName = function computeProvinceStateDisplayName() {
    var id = this.id();
    return (id ? "Province/State ".concat(id) : "(No province/state name yet)");
};


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Initialization
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
if (typeof provinceStateForm !== "object") { throw new Error("Province/State form element could not be found - did you render it using CreateProvinceStateForm?"); }
if (provinceStateForm.viewModel) { throw new Error("Province/State form has already been initialized"); }
ko.utils.extend(ProvinceStateViewModel.prototype, picklistItemExtensions.mixins);
provinceStateForm.viewModel = new ProvinceStateViewModel(provinceStateForm);

entityRegistry.provinceState.open.create = entityRegistry.provinceState.open.edit = provinceStateForm.viewModel.open;
entityRegistry.provinceState.getPicklistBehaviourData = function getPicklistBehaviourData() {
    return {
        onNewItem: provinceStateForm.viewModel.open,
        onOpenItem: provinceStateForm.viewModel.open,
        picklistData: dataCache.getObservable("provinceState")
    };
};


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Exports
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
module.exports = ProvinceStateViewModel;



//////////////////
// WEBPACK FOOTER
// ./app/picklist-provincestate/provinceStateViewModel.js
// module id = 639
// module chunks = 49